import { isArray, isString } from 'lodash';
import { UseMutationResult, useMutation } from 'react-query';

//APP
import { api } from '../../../api';
import { localConfig } from '../../../../Configs/localConfig';
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert';

//#region SALVAR ATIVIDADE
//INTERFACE
interface Params {
    nome: string,
    cod_fabricante: number,
    cod_categoria_produto: number,
    cod_classe_agronomica: number,
    cod_formulacao: number,
    cod_medida_aplicacao: number,
    observacao: string,
    ativos: {
        cod_ativo: number,
        concentracao: number
    }[],
    aplicacoes: {
        cod?: string | number,
        cod_cultura: number,
        cod_fase_cultura: number,
        cultura_nome: string,
        fase_cultura_nome: string,
        alvos: any[]
    }[],
    refetch_data_insumos_defensivos: Function,
    fecharGaveta: Function,
}

export const usePostInsumoDefensivo = (): {
    carregando_salvar_insumo_defensivo: boolean;
    mutate_salvar_insumo_defensivo: (params: Params) => void;
    isSuccess_salvar_insumo_defensivo: boolean
} => {

    const mutation: UseMutationResult<Response, Error, Params> = useMutation(
        async (params: Params) => {

            const { aplicacoes, ativos, cod_categoria_produto, cod_classe_agronomica, cod_fabricante,
                cod_formulacao, cod_medida_aplicacao, nome, observacao, refetch_data_insumos_defensivos, fecharGaveta
            } = params;

            loadingAlert({ msg: 'Salvando...', id: 'loading', autoClose: 5000 });

            return api.post(`/recomendacao/insumo-agricola?codConta=${localConfig().conta}`, {
                nome: nome,
                cod_fabricante: cod_fabricante,
                cod_categoria_produto: cod_categoria_produto,
                cod_classe_agronomica: cod_classe_agronomica,
                cod_formulacao: cod_formulacao,
                cod_medida_aplicacao: cod_medida_aplicacao,
                observacao: observacao,
                ativos: ativos,
                aplicacoes: aplicacoes
            })
                .then((response: any) => {
                    successAlert(`Defensivo salvo com sucesso!`, 5000, 'loading');
                    refetch_data_insumos_defensivos();
                    fecharGaveta();

                    return response;
                })
                .catch((error: any) => {
                    // errorAlert("Falha ao salvar atividade!", 5000, 'loading');

                    let error_msg = error?.response?.data?.error;

                    if (isArray(error_msg)) {
                        for (const error_item of error_msg) {

                            let msg_v1 = error_item?.msg?.[0];
                            let msg_v2 = error_item?.msg?.[0]?.msg?.[0]?.msg?.[0];

                            function errorMsgFinal() {
                                if (isString(msg_v1)) {
                                    return msg_v1
                                }
                                if (isString(msg_v2)) {
                                    return msg_v2
                                }
                                return 'Falha ao salvar defensivo 1!'
                            }

                            errorAlert(errorMsgFinal() ?? 'Falha ao salvar defensivo 2!', 8000, 'loading');
                        }
                    } else {
                        let error_msg_alt = error?.response?.data?.error?.[0]?.msg?.[0];
                        if (isArray(error_msg_alt)) {
                            for (const error_item of error_msg) {
                                errorAlert(error_item?.msg?.[0] ?? error_item, 8000, 'loading');
                            }
                        }

                        errorAlert((error?.response?.data?.error) ?? 'Falha salvar defensivo 3!', 5000, 'loading')
                    }

                    throw error;
                });
        }
    );

    return {
        carregando_salvar_insumo_defensivo: mutation.isLoading,
        mutate_salvar_insumo_defensivo: mutation.mutate,
        isSuccess_salvar_insumo_defensivo: mutation.isSuccess
    };
};

//#endregion